import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 text-white px-4 py-2 rounded-full mb-6">
            <Icon name="Sparkles" size={20} />
            <span className="text-sm font-medium">Free Integration Assessment</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Connect Your Systems?
          </h2>
          
          <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Get a free technical consultation and integration roadmap. Our experts will analyze your systems and provide a detailed implementation plan with timeline and cost estimates.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link to="/contact">
              <Button 
                variant="default" 
                size="lg"
                className="bg-white text-primary hover:bg-white/90"
                iconName="Calendar"
                iconPosition="left"
              >
                Schedule Technical Consultation
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg"
              className="border-white text-white hover:bg-white/10"
              iconName="MessageSquare"
              iconPosition="left"
            >
              Chat on WhatsApp
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            {[
              { icon: 'Shield', text: 'Enterprise Security' },
              { icon: 'Clock', text: '24/7 Support' },
              { icon: 'Award', text: 'Certified Experts' }
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center space-x-2 text-white">
                <Icon name={item.icon} size={20} />
                <span className="text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;